import { default as indexafOzMwXBOHMeta } from "/home/msservice/workspace/MAYBE/PROD/PROD-MAYBE-V3-FE/maybe-v3-fe-prod/pages/[slug]/index.vue?macro=true";
import { default as _404mvvvFD1qbbMeta } from "/home/msservice/workspace/MAYBE/PROD/PROD-MAYBE-V3-FE/maybe-v3-fe-prod/pages/404.vue?macro=true";
import { default as index1UYHxCLSrLMeta } from "/home/msservice/workspace/MAYBE/PROD/PROD-MAYBE-V3-FE/maybe-v3-fe-prod/pages/account-trial/index.vue?macro=true";
import { default as indexb7yJ8noggjMeta } from "/home/msservice/workspace/MAYBE/PROD/PROD-MAYBE-V3-FE/maybe-v3-fe-prod/pages/account/index.vue?macro=true";
import { default as indexDa97NxhUrRMeta } from "/home/msservice/workspace/MAYBE/PROD/PROD-MAYBE-V3-FE/maybe-v3-fe-prod/pages/dua-top-ngoai-hang-anh/index.vue?macro=true";
import { default as eventAfUMg82nMFMeta } from "/home/msservice/workspace/MAYBE/PROD/PROD-MAYBE-V3-FE/maybe-v3-fe-prod/pages/event.vue?macro=true";
import { default as indexTJEyXrHC6TMeta } from "/home/msservice/workspace/MAYBE/PROD/PROD-MAYBE-V3-FE/maybe-v3-fe-prod/pages/huong-dan/index.vue?macro=true";
import { default as indexyMYgFUdWYcMeta } from "/home/msservice/workspace/MAYBE/PROD/PROD-MAYBE-V3-FE/maybe-v3-fe-prod/pages/index.vue?macro=true";
import { default as indexwi9bQ0cBYDMeta } from "/home/msservice/workspace/MAYBE/PROD/PROD-MAYBE-V3-FE/maybe-v3-fe-prod/pages/khuyen-mai/index.vue?macro=true";
import { default as indexokxxW1ZwvDMeta } from "/home/msservice/workspace/MAYBE/PROD/PROD-MAYBE-V3-FE/maybe-v3-fe-prod/pages/live-casino/index.vue?macro=true";
import { default as lobby_45gameNavds60q9FMeta } from "/home/msservice/workspace/MAYBE/PROD/PROD-MAYBE-V3-FE/maybe-v3-fe-prod/pages/lobby-game.vue?macro=true";
import { default as maintenance4cqYJ8QyF9Meta } from "/home/msservice/workspace/MAYBE/PROD/PROD-MAYBE-V3-FE/maybe-v3-fe-prod/pages/maintenance.vue?macro=true";
import { default as indexoHdttqF6ayMeta } from "/home/msservice/workspace/MAYBE/PROD/PROD-MAYBE-V3-FE/maybe-v3-fe-prod/pages/the-thao/index.vue?macro=true";
import { default as lich_45thi_45dauFv6LRXGu9hMeta } from "/home/msservice/workspace/MAYBE/PROD/PROD-MAYBE-V3-FE/maybe-v3-fe-prod/pages/the-thao/lich-thi-dau.vue?macro=true";
import { default as indexDsFarabr31Meta } from "/home/msservice/workspace/MAYBE/PROD/PROD-MAYBE-V3-FE/maybe-v3-fe-prod/pages/tin-tuc/index.vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug()",
    meta: indexafOzMwXBOHMeta || {},
    component: () => import("/home/msservice/workspace/MAYBE/PROD/PROD-MAYBE-V3-FE/maybe-v3-fe-prod/pages/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: "404",
    path: "/404",
    component: () => import("/home/msservice/workspace/MAYBE/PROD/PROD-MAYBE-V3-FE/maybe-v3-fe-prod/pages/404.vue").then(m => m.default || m)
  },
  {
    name: "account-trial",
    path: "/account-trial",
    component: () => import("/home/msservice/workspace/MAYBE/PROD/PROD-MAYBE-V3-FE/maybe-v3-fe-prod/pages/account-trial/index.vue").then(m => m.default || m)
  },
  {
    name: "account",
    path: "/account",
    meta: indexb7yJ8noggjMeta || {},
    component: () => import("/home/msservice/workspace/MAYBE/PROD/PROD-MAYBE-V3-FE/maybe-v3-fe-prod/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: "dua-top-ngoai-hang-anh",
    path: "/dua-top-ngoai-hang-anh",
    component: () => import("/home/msservice/workspace/MAYBE/PROD/PROD-MAYBE-V3-FE/maybe-v3-fe-prod/pages/dua-top-ngoai-hang-anh/index.vue").then(m => m.default || m)
  },
  {
    name: "event",
    path: "/event",
    component: () => import("/home/msservice/workspace/MAYBE/PROD/PROD-MAYBE-V3-FE/maybe-v3-fe-prod/pages/event.vue").then(m => m.default || m)
  },
  {
    name: "huong-dan",
    path: "/huong-dan",
    component: () => import("/home/msservice/workspace/MAYBE/PROD/PROD-MAYBE-V3-FE/maybe-v3-fe-prod/pages/huong-dan/index.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    meta: indexyMYgFUdWYcMeta || {},
    component: () => import("/home/msservice/workspace/MAYBE/PROD/PROD-MAYBE-V3-FE/maybe-v3-fe-prod/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "khuyen-mai",
    path: "/khuyen-mai",
    component: () => import("/home/msservice/workspace/MAYBE/PROD/PROD-MAYBE-V3-FE/maybe-v3-fe-prod/pages/khuyen-mai/index.vue").then(m => m.default || m)
  },
  {
    name: "live-casino",
    path: "/live-casino",
    component: () => import("/home/msservice/workspace/MAYBE/PROD/PROD-MAYBE-V3-FE/maybe-v3-fe-prod/pages/live-casino/index.vue").then(m => m.default || m)
  },
  {
    name: "lobby-game",
    path: "/lobby-game",
    component: () => import("/home/msservice/workspace/MAYBE/PROD/PROD-MAYBE-V3-FE/maybe-v3-fe-prod/pages/lobby-game.vue").then(m => m.default || m)
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/home/msservice/workspace/MAYBE/PROD/PROD-MAYBE-V3-FE/maybe-v3-fe-prod/pages/maintenance.vue").then(m => m.default || m)
  },
  {
    name: "the-thao",
    path: "/the-thao",
    component: () => import("/home/msservice/workspace/MAYBE/PROD/PROD-MAYBE-V3-FE/maybe-v3-fe-prod/pages/the-thao/index.vue").then(m => m.default || m)
  },
  {
    name: "the-thao-lich-thi-dau",
    path: "/the-thao/lich-thi-dau",
    component: () => import("/home/msservice/workspace/MAYBE/PROD/PROD-MAYBE-V3-FE/maybe-v3-fe-prod/pages/the-thao/lich-thi-dau.vue").then(m => m.default || m)
  },
  {
    name: "tin-tuc",
    path: "/tin-tuc",
    component: () => import("/home/msservice/workspace/MAYBE/PROD/PROD-MAYBE-V3-FE/maybe-v3-fe-prod/pages/tin-tuc/index.vue").then(m => m.default || m)
  }
]